module.exports = __webpack_public_path__ + "static/media/Emerging Leaders Video_1601307789398.62e2bff3.docx";